import { render, staticRenderFns } from "./TextShow.vue?vue&type=template&id=4fc3b41e&scoped=true&"
import script from "./TextShow.vue?vue&type=script&lang=ts&"
export * from "./TextShow.vue?vue&type=script&lang=ts&"
import style0 from "./TextShow.vue?vue&type=style&index=0&id=4fc3b41e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc3b41e",
  null
  
)

export default component.exports